import React, { useEffect } from 'react';
import { Button } from '../../../ui';

const ResumeEngineProcessingStep = ({
  onRefreshResumeContext,
  isRefreshing = false,
  initialEvaluation = null,
  onFatalError,
  onViewRequests
}) => {
  const evaluationStatus = initialEvaluation?.status || 'processing';
  const pollAfterMs = Math.max(1000, Number(initialEvaluation?.poll_after_ms || 3000));
  const isTechnicalFailure = evaluationStatus === 'technical_failure';

  useEffect(() => {
    if (evaluationStatus !== 'processing' || isRefreshing) {
      return undefined;
    }

    const timeoutId = window.setTimeout(() => {
      onRefreshResumeContext();
    }, pollAfterMs);

    return () => window.clearTimeout(timeoutId);
  }, [evaluationStatus, isRefreshing, onRefreshResumeContext, pollAfterMs]);

  return (
    <div className="container py-4">
      <div className="card border-0 shadow-sm">
        <div className="card-body text-center p-4">
          <h2 className="h5 mb-3">
            {isTechnicalFailure ? 'No pudimos completar la evaluación' : 'Estamos evaluando la solicitud'}
          </h2>
          <p className="text-muted mb-4">
            {isTechnicalFailure
              ? (initialEvaluation?.message || 'Podés salir y retomar la solicitud más tarde.')
              : 'Cuando finalice el análisis vas a poder continuar con la oferta.'}
          </p>
          {!isTechnicalFailure ? (
            <Button
              variant="primary"
              onClick={onRefreshResumeContext}
              disabled={isRefreshing}
            >
              {isRefreshing ? 'Consultando...' : 'Volver a consultar'}
            </Button>
          ) : (
            <div className="d-flex justify-content-center gap-2">
              {typeof onViewRequests === 'function' ? (
                <Button variant="secondary" onClick={onViewRequests}>
                  Ver solicitudes
                </Button>
              ) : null}
              {typeof onFatalError === 'function' ? (
                <Button variant="primary" onClick={onFatalError}>
                  Volver al perfil
                </Button>
              ) : null}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ResumeEngineProcessingStep;
